export const settingsPl = {
  settings: {
    common: {
      save: 'Zapisz',
      add: 'Dodaj',
      edit: 'Edytuj',
      cancel: 'Anuluj',
    },
    nav: {
      account: 'Konto',
      security: 'Bezpieczeństwo',
      connections: 'Połączenia',
      connectionsDescription: 'Konta OAuth do logowania i skrót do integracji workspace',
      agents: 'Agenci',
      storage: 'Magazyn',
      workspaceIntegrationsTitle: 'Integracje workspace',
      workspaceIntegrationsDescription: 'GitHub, Jira i GitLab używane przez agenta w czacie',
      workspaceIntegrationsLink: 'Przejdź do integracji workspace',
    },
    agents: {
      title: 'Agenci',
      description: 'Konfiguruj agentów dostępnych w czacie tego workspace (owner/admin).',
      create: 'Nowy agent',
      createTitle: 'Utwórz agenta',
      editTitle: 'Edytuj agenta',
      loading: 'Ładowanie agentów…',
      empty: 'Brak agentów.',
      selectHint: 'Wybierz agenta do edycji albo utwórz nowego.',
      memberHint: 'Tylko owner/admin workspace mogą edytować agentów. W czacie nadal możesz ich wybierać.',
      loadError: 'Nie udało się wczytać agentów',
      saveError: 'Nie udało się zapisać agenta',
      created: 'Agent utworzony',
      saved: 'Agent zapisany',
      defaultSet: 'Zaktualizowano domyślnego agenta',
      setDefault: 'Ustaw jako domyślnego',
      defaultBadge: 'Domyślny',
      disabledBadge: 'Wyłączony',
      fields: {
        key: 'Klucz',
        name: 'Nazwa',
        description: 'Opis',
        systemPrompt: 'System prompt',
        model: 'Nadpisanie modelu',
        modelPlaceholder: 'Puste = domyślny model workspace',
        tools: 'Buckety narzędzi',
        rag: 'RAG włączony',
        enabled: 'Włączony',
        default: 'Domyślny agent',
      },
    },
    page: {
      title: 'Ustawienia',
      subtitle: 'Zarządzaj preferencjami i własnymi kategoriami',
      save: 'Zapisz',
      error_prefix: 'Błąd ładowania ustawień',
      sections: {
        preferences: {
          title: 'Preferencje',
          description: 'Zarządzaj ogólnymi preferencjami i ustawieniami',
        },
        theme: {
          label: 'Motyw',
          subtitle: 'Wybierz jasny lub ciemny motyw',
          placeholder: 'Wybierz motyw',
          group_label: 'Motyw',
          options: {
            light: 'Jasny',
            dark: 'Ciemny',
          },
        },
        locale: {
          label: 'Język',
          subtitle: 'Język używany w interfejsie',
          placeholder: 'Wybierz język',
          group_label: 'Język',
          options: {
            en: 'English',
            pl: 'Polski',
          },
        },
        defaultContainersPublic: {
          label: 'Nowe kontenery domyślnie publiczne',
          subtitle: 'Po włączeniu, nowo utworzone kontenery będą domyślnie publiczne',
        },
        profilePublic: {
          label: 'Udostępnij profil publicznie',
          subtitle: 'Pozwól innym zalogowanym użytkownikom przeglądać Twój publiczny profil',
        },
        emailPublic: {
          label: 'Pokaż email w profilu publicznym',
          subtitle: 'Wyświetlaj swój adres email w profilu publicznym (tylko jeśli profil jest publiczny)',
        },
      },
    },
    security: {
      title: 'Bezpieczeństwo',
      description: 'Zarządzaj bezpieczeństwem konta i uwierzytelnianiem dwuskładnikowym',
      setup: 'Włącz 2FA',
      manage: 'Zarządzaj 2FA',
      login_required: 'Zaloguj się, aby zarządzać ustawieniami bezpieczeństwa i uwierzytelnianiem dwuskładnikowym.',
      not_configured: 'Uwierzytelnianie dwuskładnikowe nie jest włączone. Włącz je dla lepszego bezpieczeństwa.',
      totp: {
        title: 'Aplikacja uwierzytelniająca',
        enabled: 'Włączona',
        disabled: 'Nie skonfigurowana',
      },
      passkeys: {
        title: 'Klucze dostępu',
        enabled: 'Włączone',
        disabled: 'Nie skonfigurowane',
        count: '{count} kluczy dostępu | {count} klucz dostępu | {count} klucze dostępu | {count} kluczy dostępu',
      },
      preferred_method: {
        title: 'Preferowana metoda 2FA',
        description: 'Ustaw preferowaną metodę uwierzytelniania dwuskładnikowego',
        label: 'Preferowana metoda',
        placeholder: 'Wybierz preferowaną metodę',
        options: {
          none: 'Automatycznie',
          totp: 'Aplikacja uwierzytelniająca',
          webauthn: 'Klucze dostępu',
        },
        saved: 'Zaktualizowano preferowaną metodę',
        error: 'Nie udało się zaktualizować preferowanej metody',
      },
    },
    preferences: {
      title: 'Preferencje Sprzętu',
      description: 'Zarządzaj preferencjami i ustawieniami workspace',
      save: 'Zapisz',
      saved: 'Zapisano',
      preferredWeightUnit: {
        label: 'Preferowana Jednostka Wagi',
        subtitle: 'Domyślna jednostka wyświetlania wag w całej aplikacji',
        placeholder: 'Wybierz jednostkę wagi',
        options: {
          g: 'Gramy (g)',
          kg: 'Kilogramy (kg)',
          oz: 'Uncje (oz)',
          lb: 'Funty (lb)',
          'auto-g-kg': 'Auto (g/kg)',
          'auto-oz-lb': 'Auto (oz/lb)',
        },
      },
      defaultCurrency: {
        label: 'Domyślna Waluta',
        subtitle: 'Domyślna waluta dla cen w przedmiotach i kontenerach',
        placeholder: 'Wybierz walutę',
      },
      imageProcessingMode: {
        label: 'Tryb Przetwarzania Obrazków',
        subtitle: 'Wybierz sposób przetwarzania przesyłanych obrazków (zmiana rozmiaru i kompresja)',
        options: {
          highQuality: 'Wysoka Jakość',
          highQualityDescription: 'Maksymalny rozmiar: 2560x2560px, jakość JPEG: 95%. Najlepsza jakość, większy rozmiar pliku.',
          balanced: 'Zbalansowany',
          balancedDescription: 'Maksymalny rozmiar: 1200x1200px, jakość JPEG: 90%. Dobra równowaga między jakością a rozmiarem pliku.',
          storageSaver: 'Oszczędny',
          storageSaverDescription: 'Maksymalny rozmiar: 800x800px, jakość JPEG: 80%. Mniejszy rozmiar pliku, niższa jakość.',
        },
      },
    },
    categories: {
      title: 'Własne Kategorie',
      description: 'Dodawaj i zarządzaj własnymi kategoriami przedmiotów',
      add: 'Dodaj Kategorię',
      edit: 'Edytuj Kategorię',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć tę kategorię?',
      valuePlaceholder: 'Nazwa kategorii',
      valueRequired: 'Nazwa kategorii jest wymagana',
      empty: 'Brak własnych kategorii. Dodaj pierwszą powyżej.',
    },
    containerTypes: {
      title: 'Własne Typy Kontenerów',
      description: 'Dodawaj i zarządzaj własnymi typami kontenerów',
      add: 'Dodaj Typ Kontenera',
      edit: 'Edytuj Typ Kontenera',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten typ kontenera?',
      valuePlaceholder: 'Nazwa typu kontenera',
      valueRequired: 'Nazwa typu kontenera jest wymagana',
      empty: 'Brak własnych typów kontenerów. Dodaj pierwszy powyżej.',
    },
    brands: {
      title: 'Własne Marki',
      description: 'Dodawaj i zarządzaj własnymi markami przedmiotów',
      add: 'Dodaj Markę',
      edit: 'Edytuj Markę',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć tę markę?',
      valuePlaceholder: 'Nazwa marki',
      valueRequired: 'Nazwa marki jest wymagana',
      empty: 'Brak własnych marek. Dodaj pierwszą powyżej.',
    },
    oauth: {
      title: 'Połączenia OAuth',
      description: 'Zarządzaj powiązanymi kontami OAuth (Google, Facebook itp.)',
      login_required: 'Zaloguj się, aby zarządzać połączeniami OAuth.',
      no_connections: 'Brak powiązanych kont OAuth.',
      providers: {
        google: 'Google',
        facebook: 'Facebook',
        github: 'GitHub',
      },
      connection: {
        linked: 'Połączone',
        deleted: 'Połączenie OAuth zostało usunięte',
        confirm_delete: 'Czy na pewno chcesz usunąć połączenie z {provider}?',
      },
    },
    integrations: {
      title: 'Integracje',
      description: 'Połącz GitHub i inne narzędzia dla agentów AI (tokeny OAuth per-user)',
      login_required: 'Zaloguj się, aby zarządzać integracjami.',
      connections_title: 'Aktywne połączenia',
      no_connections: 'Brak podłączonych integracji.',
      tenant_required: 'Wybierz aktywny workspace (tenant), zanim podłączysz integracje.',
      github_not_configured: 'OAuth GitHub nie jest skonfigurowany na serwerze.',
      gmail_not_configured: 'OAuth Gmail nie jest skonfigurowany na serwerze.',
      github_app_permissions_hint:
        'GitHub App: uprawnienia API wynikają z manifestu aplikacji na GitHubie (nie z pól scope poniżej). Włącz Issues, Pull requests i Contents (odczyt).',
      providers: {
        github: 'GitHub',
        gmail: 'Gmail',
      },
      scopes: {
        title: 'Uprawnienia (scope)',
        github: {
          read_user: 'Odczyt profilu użytkownika',
          read_user_desc: 'Wymagane do identyfikacji konta GitHub.',
          repo: 'Dostęp do repozytoriów',
          repo_desc: 'Odczyt issue, pull requestów i metadanych repozytoriów.',
        },
        gmail: {
          openid: 'OpenID',
          openid_desc: 'Tożsamość logowania konta Google.',
          email: 'Adres e-mail',
          email_desc: 'Odczyt e-maila konta Google (userinfo.email).',
          profile: 'Profil',
          profile_desc: 'Odczyt nazwy i zdjęcia profilu Google.',
          readonly: 'Gmail tylko do odczytu',
          readonly_desc: 'Wyszukiwanie i odczyt wiadomości (bez wysyłania i zmian).',
        },
      },
      visibility: {
        title: 'Widoczność',
        user: 'Osobista',
        team: 'Zespół',
        tenant: 'Tenant',
        user_hint: 'Tylko Ty możesz używać tego połączenia w agentach.',
        team_hint: 'Wszyscy członkowie wybranego zespołu mogą używać tego połączenia.',
        tenant_hint: 'Wszyscy członkowie bieżącego tenanta mogą używać tego połączenia.',
        team_select: 'Zespół',
      },
      connect: {
        github: 'Połącz GitHub',
        gmail: 'Połącz Gmail',
        redirecting: 'Przekierowanie do GitHub…',
        redirecting_gmail: 'Przekierowanie do Google…',
      },
      connection: {
        linked: 'Połączone',
        deleted: 'Połączenie integracji zostało usunięte',
        confirm_delete: 'Usunąć integrację {provider}?',
      },
      callback: {
        processing_title: 'Łączenie integracji',
        failed_title: 'Połączenie nie powiodło się',
        processing: 'Kończenie autoryzacji {provider}…',
        success: 'Połączono {provider}',
        failed: 'Nie udało się połączyć integracji',
        cancelled: 'Autoryzacja została anulowana',
        invalid_parameters: 'Nieprawidłowe parametry OAuth',
        invalid_state: 'Nieprawidłowy stan OAuth — spróbuj ponownie',
      },
    },
    storage: {
      title: 'Użycie Miejsca',
      description: 'Zobacz użycie i limity miejsca na pliki',
      used: 'Użyto',
      usagePercentage: 'Użycie',
      error: 'Nie można załadować informacji o miejscu',
    },
    delete_account: {
      title: 'Usuń Konto',
      description: 'Trwale usuń swoje konto i wszystkie powiązane dane',
      warning_title: 'Ostrzeżenie: Ta akcja nie może być cofnięta',
      warning_1: 'Wszystkie Twoje dane zostaną trwale usunięte',
      warning_2: 'Utracisz dostęp do wszystkich swoich kontenerów i przedmiotów',
      warning_3: 'Ta akcja nie może być odwrócona',
      button: 'Usuń Konto',
      modal: {
        title: 'Usuń Konto',
        description: 'Czy na pewno chcesz usunąć swoje konto? Ta akcja nie może być cofnięta.',
        warning_title: 'Ostatnie Ostrzeżenie',
        warning_text: 'Po usunięciu konta wszystkie Twoje dane zostaną trwale usunięte i nie będą mogły zostać odzyskane.',
        confirmation_label: 'Wpisz DELETE aby potwierdzić',
        confirmation_hint: 'Proszę wpisać DELETE w polu powyżej, aby potwierdzić usunięcie konta',
        confirm_checkbox: 'Rozumiem, że ta akcja nie może być cofnięta i wszystkie moje dane zostaną trwale usunięte',
        cancel: 'Anuluj',
        delete_button: 'Usuń Konto',
        success: 'Konto zostało pomyślnie usunięte',
        errors: {
          invalid_confirmation: 'Nieprawidłowe potwierdzenie. Proszę wpisać DELETE aby potwierdzić.',
          generic: 'Nie udało się usunąć konta. Proszę spróbować ponownie.',
        },
      },
    },
  },
}

